import React, { useEffect, useState } from 'react'
import { Box, Select, FormControl, Stack, Text, Input } from '@/components/lib'
import utils from '../../utils/utils'
import useStore from '../../store'

export default function WeightEditor ({ value, onChange }) {
  const { settings, changeSetting } = useStore()
  const measurement = settings?.weightMeasureType || 'metric'
  const [weight, setWeight] = useState()
  const [weightPounds, setWeightPounds] = useState()
  const [weightOunces, setWeightOunces] = useState()

  useEffect(() => {
    const val = value?.toString() || ''
    setWeight(val)
    const imperial = utils.kToLbs(val || 0)
    if (imperial) {
      setWeightPounds(imperial.pounds)
      setWeightOunces(imperial.ounces)
    }
  }, [value])

  const updateMetricWeight = kg => {
    if (kg === '' || parseFloat(kg) >= 0) {
      setWeight(kg)
      onChange(kg)
    }
    const imperial = utils.kToLbs(kg || 0)
    if (imperial) {
      setWeightPounds(imperial.pounds)
      setWeightOunces(imperial.ounces)
    }
  }

  const updateImperialWeight = (pounds, ounces) => {
    setWeightPounds(pounds)
    if (ounces === '' || (parseFloat(ounces) >= 0 && parseFloat(ounces) < 16)) {
      setWeightOunces(ounces)
    }
    if (!pounds && !ounces) {
      setWeight('')
      onChange('')
    } else if (pounds || ounces) {
      const kg = utils.lbToK(pounds || 0, ounces || 0)
      setWeight(kg)
      onChange(kg)
    }
  }

  return (
    <Box>
      <Box>
        <Select
          w='200px' placeholder='Measurement type...' size='xs' mr={2} bg='bg.surface'
          value={measurement}
          onChange={e => changeSetting('weightMeasureType', e.target.value || 'metric')}
        >
          <option value='metric'>Metric (kg)</option>
          <option value='imperial'>Imperial (lb & oz)</option>
        </Select>
      </Box>

      <Box display={{ md: 'flex' }} mt={2}>
        {measurement === 'metric' &&
          <>
            <FormControl bg='bg.accent' rounded='md' p={2} w='150px' label='Weight'>
              <Stack direction='row' alignItems='center'>
                <Input width='80px' bg='bg.surface' size='sm' value={weight ?? ''} onChange={e => updateMetricWeight(e.target.value.replace(/[^\d.]/g, ''))} />
                <Text>kg</Text>
              </Stack>
            </FormControl>
          </>}

        {measurement === 'imperial' &&
          <>
            <FormControl bg='bg.accent' rounded='md' p={2} w='300px' label='Weight'>
              <Stack direction='row' alignItems='center' spacing={10}>
                <Stack direction='row' alignItems='center'>
                  <Input width='60px' bg='bg.surface' size='sm' value={weightPounds ?? ''} onChange={e => updateImperialWeight(e.target.value.replace(/[^\d.]/g, ''), weightOunces)} />
                  <Text>pounds</Text>
                </Stack>
                <Stack direction='row' alignItems='center'>
                  <Input width='60px' bg='bg.surface' size='sm' value={weightOunces ?? ''} onChange={e => updateImperialWeight(weightPounds, e.target.value.replace(/[^\d.]/g, ''))} />
                  <Text>ounces</Text>
                </Stack>
              </Stack>
            </FormControl>
          </>}
      </Box>
    </Box>
  )
}
